import HistoryDetails from 'features/payOverTime/screens/ManageLoans/HistoryTab/HistoryDetails';
import React from 'react';

export default function Page() {
  return <HistoryDetails />;
}
